import { Component, Input } from '@angular/core';
import { IReport, ISignature, ReportStatus } from '@shared/interfaces';
import { ThemeService } from '@shared/services';
import { IS_PRODUCT_SAFETY_PROJECT, IS_TRS_PROJECT } from '../../../../current-project';

@Component({
    selector: 'app-report-tile',
    templateUrl: './report-tile.component.html',
    styleUrls: ['./report-tile.component.scss'],
    standalone: false
})
export class ReportTileComponent {
    IS_TRS_PROJECT = IS_TRS_PROJECT;
    IS_PRODUCT_SAFETY_PROJECT = IS_PRODUCT_SAFETY_PROJECT;

    @Input() item: IReport;
    @Input() isPlaceholder: boolean;
    @Input() isPlaceholderLight: boolean;
    @Input() auto: boolean;
    @Input() basic: boolean;
    @Input() showHeader = true;
    @Input() showShadow = true;

    constructor(private themeService: ThemeService) {}

    get innerStrokeColor(): string {
        if (!this.item) {
            return '';
        }

        return this.themeService.getThemeVariables().circleInnerColor;
    }

    get outerStrokeColor(): string {
        if (!this.item) {
            return '';
        }

        switch (this.item.reportStatus) {
            case ReportStatus.draft:
                return this.themeService.getThemeVariables().reportDraftColor;
            case ReportStatus.inProgress:
                return this.themeService.getThemeVariables().reportInProgressColor;
            default:
                return this.themeService.getThemeVariables().reportCompletedColor;
        }
    }

    get specialistSigners(): string {
        return (this.item?.specialistSignature as ISignature[])?.map(e => e.fullName).join(', ');
    }
}
